import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {CompleterData, CompleterItem, CompleterService} from 'ng2-completer';
import {ApiService} from '../../../@core/service/api.service';
import {ContactModel, EBusinessType, EContactType, EParticipantType, ParticipantModel} from '../../../@models';
import {Subject} from 'rxjs';

@Component({
  selector: 'ngx-form-participant',
  templateUrl: './form-participant.component.html',
  styleUrls: ['./form-participant.component.scss'],
})

export class FormParticipantComponent implements OnInit, OnDestroy, OnChanges {
  @Input() title: string;
  @Input() value: ParticipantModel[];

  @Output() valueChange: EventEmitter<ParticipantModel[]> = new EventEmitter<ParticipantModel[]>();

  @Input() edit: boolean = true;
  @Input() businessId: string;

  contactService: CompleterData;

  contactName: string;

  newParticipantName: string;
  newParticipant: ContactModel;

  isExternal: boolean;
  onlyCustomer: boolean = true;
  onlyNrk: boolean = true;

  JSON = JSON;

  private contactSubject = new Subject();
  private contactSubscription: any;

  constructor(private api: ApiService, private completerService: CompleterService) {
    this.contactSubject = new Subject();
    // this.api.reloadContacts({contactType: EContactType.Employee}).subscribe(x => this.contactSubject.next(x));

    this.contactService = this.completerService.local(
      this.contactSubject, 'displayTitle', 'displayTitle')

  }


  ngOnInit() {
    this.reload();
    this.contactSubscription = this.api.contactsChanged.subscribe(() => {
      this.reload();
    });
  }

  ngOnDestroy(): void {
    if (this.contactSubscription != null) this.contactSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    /* if (!this.changeCommited) {
      this.tagList = changes.value.currentValue.map(x => {
        return {
          value: x._id,
          display: `${x.business.name}: ${x.title}`,
        }
      });
    }*/
    // if (changes.value != null && changes.value.currentValue != null)
    // this.projectName = changes.value.currentValue.name;

    // this.changeCommited = false;
  }
  select(item: CompleterItem) {
    // console.log(item);
    if (item != null)
      this.newParticipant = item.originalObject;
    // this.changeCommited = true;
    // this.valueChange.emit();
  }

  selectOnlyCustomer(value: Boolean) {
    this.reload();

    // this.contactService.dataSourceChange =
    // this.api.reloadContacts({contactType: EContactType.Employee});
  }

  private reload() {
    const filter: any = {contactType: EContactType.Employee};
    if (this.onlyNrk) filter.type = EBusinessType.NRK;
    if (this.onlyCustomer && this.businessId) filter.business = this.businessId;

    this.api.reloadContacts(filter).subscribe(x => this.contactSubject.next(x));
  }

  selectOnlyNrk(value: Boolean) {
    this.reload();
  }

  addParticipant() {
    if (this.value == null) this.value = [];


    if (this.isExternal) {
      if (this.value.find(x => x.name === this.newParticipantName) != null)
        return;

      this.value.push({
        contact: null,
        name: this.newParticipantName,
        type: EParticipantType.External,
      })
    } else {
      const newName = `${this.newParticipant?.business?.name}: ${this.newParticipant?.title}`;
      if (this.value.find(x => x.name === newName) != null)
        return;
      this.value.push({
        contact: this.newParticipant?._id,
        name: this.newParticipant.displayTitle,
        type: EParticipantType.Reference,
      });
    }
    this.valueChange.emit(this.value);
    this.newParticipant = null;
    this.newParticipantName = '';
  }


  remove(item: ParticipantModel) {
    this.value = this.value.filter(x => x.name !== item.name)
    this.valueChange.emit(this.value);

  }
}
